import { Pipe, PipeTransform } from "@angular/core";
import { Files } from "../../app/api/packbo/models/files";
import { environment } from "../../environments/environment";

export type GetDirectusImageOptions = {
    format?: "png" | "jpg" | "webp";
    fit?: "cover" | "contain";
    quality?: number;
    width?: number;
    height?: number;
};

@Pipe({
    name: "getDirectusImage",
    standalone: true,
    pure: true
})
export class GetDirectusImagePipe implements PipeTransform {
    transform(
        fileId: Files | string | null | undefined,
        options: GetDirectusImageOptions = { format: "webp" }
    ): string {
        const imageId = typeof fileId === "string" ? fileId : fileId?.id;
        const url = `${environment.directusUrl}/assets/${imageId}`;

        if (options) {
            const params = new URLSearchParams();

            for (const [key, value] of Object.entries(options)) {
                if (value !== undefined) {
                    params.set(key, value.toString());
                }
            }

            return `${url}?${params.toString()}`;
        }

        return url;
    }
}
